import { useCallback, useEffect, useRef, useState } from 'react';

import { RefreshIcon } from '@/ui/Icons/RefreshIcon';

export function SpinningRefreshIcon({ isSpinning }: { isSpinning: boolean }) {
  const [animating, setAnimating] = useState(false);
  const shouldStopRef = useRef(false);

  useEffect(() => {
    if (isSpinning) {
      shouldStopRef.current = false;
      setAnimating(true);
    } else {
      shouldStopRef.current = true;
    }
  }, [isSpinning]);

  const handleIterationEnd = useCallback(() => {
    if (shouldStopRef.current) {
      setAnimating(false);
    }
  }, []);

  return (
    <span
      className={
        animating
          ? 'inline-flex animate-[spin_0.6s_cubic-bezier(0.4,0,0.2,1)_infinite]'
          : 'inline-flex'
      }
      onAnimationIteration={handleIterationEnd}
    >
      <RefreshIcon className="size-4" />
    </span>
  );
}
